import React from "react";
import { fmtNum, fmtMoneyShort } from "@/lib/format";

function hexToRgba(hex, a) {
  const h = hex.replace("#", "");
  const n = parseInt(h.length === 3 ? h.split("").map((c) => c + c).join("") : h, 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${a})`;
}

export default function KpiCard({ label, count, value, valueLabel, accent, icon: Icon, delta, deltaPct, goodWhenDown, onClick, testId }) {
  const hasDelta = delta !== null && delta !== undefined && delta !== 0;
  const good = goodWhenDown ? delta < 0 : delta > 0;
  const up = delta > 0;
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      className="kcard kcard-click text-left p-4 w-full relative overflow-hidden group"
      style={{ background: `linear-gradient(165deg, ${hexToRgba(accent, 0.07)} 0%, #ffffff 42%)` }}
    >
      <div className="flex items-start justify-between">
        <span className="label-eyebrow pt-0.5">{label}</span>
        <span className="w-9 h-9 rounded-full grid place-items-center shrink-0 transition-transform duration-200 group-hover:scale-110"
          style={{ background: hexToRgba(accent, 0.12), color: accent }}>
          {Icon && <Icon className="w-[18px] h-[18px]" strokeWidth={2.2} />}
        </span>
      </div>
      <div className="mt-3 text-[28px] leading-none font-bold num text-slate-900 tracking-tight">{fmtNum(count)}</div>
      <div className="mt-3 pt-2.5 border-t border-[var(--line)] flex items-center justify-between gap-2">
        <div className="flex items-baseline gap-1.5 min-w-0">
          <span className="text-[13px] font-bold num" style={{ color: accent }}>{fmtMoneyShort(value)}</span>
          <span className="text-[10px] text-slate-400 truncate">{valueLabel}</span>
        </div>
        {hasDelta && (
          <span className={`shrink-0 inline-flex items-center gap-0.5 text-[10.5px] font-semibold num px-1.5 py-0.5 rounded-full ${good ? "bg-emerald-50 text-emerald-700" : "bg-rose-50 text-rose-700"}`}>
            {up ? "▲" : "▼"} {fmtNum(Math.abs(delta))}{deltaPct != null ? ` ${Math.abs(deltaPct).toFixed(1)}%` : ""}
          </span>
        )}
      </div>
    </button>
  );
}
